export const defaultFontSize = 16;
export const maxFontSize = 32;
export const fontOffset = 2.2;
export const maxFontResizeLength = 10;
export const category = {
  diagnostics: 'diagnostics',
  general: 'general',
};
export const ticketActionIds = {
  closeTicket: 'closeTicket',
};

